import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Flex, Box, BoxProps, Grid } from '../grid';
import { CroppedText, Heading } from '../typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
interface Props {
  heading: any;
  subheading?: any;
  callToAction?: any;
  className?: string;
  icon?: IconProp;
}
const EmptyState = t0 => {
  const $ = _c(26);
  let heading;
  let icon;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      heading,
      subheading: t1,
      callToAction: t2,
      icon,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = heading;
    $[2] = icon;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
  } else {
    heading = $[1];
    icon = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const subheading = t1 === undefined ? "" : t1;
  const callToAction = t2 === undefined ? "" : t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      height: "100%",
      textAlign: "center"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justifyItems: "center",
      width: "100%"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== icon) {
    t5 = icon && <FontAwesomeIcon icon={icon} size="2x" />;
    $[8] = icon;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <Box mb={2} color="gray.2">{t5}</Box>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== heading) {
    t7 = <Heading fontSize={3} fontWeight="bold">{heading}</Heading>;
    $[12] = heading;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== subheading) {
    t8 = subheading && <CroppedText sx={{
      maxWidth: "700px"
    }}>{subheading}</CroppedText>;
    $[14] = subheading;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== callToAction) {
    t9 = callToAction && <Flex flexWrap="wrap" justifyContent="center" sx={{
      maxWidth: "700px",
      width: "100%"
    }}>{callToAction}</Flex>;
    $[16] = callToAction;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <Grid gridGap={4} sx={t4}>{t6}{t7}{t8}{t9}</Grid>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== rest || $[24] !== t10) {
    t11 = <Flex alignSelf="center" justifyContent="center" alignItems="center" flexDirection="column" p={4} sx={t3} {...rest}>{t10}</Flex>;
    $[23] = rest;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};
export default EmptyState;